import { render, staticRenderFns } from "./ClicTable.vue?vue&type=template&id=7af5d732&"
import script from "./ClicTable.vue?vue&type=script&lang=js&"
export * from "./ClicTable.vue?vue&type=script&lang=js&"
import style0 from "./ClicTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports